import { css } from '@emotion/core'
import styled from '@emotion/styled'

import svgDragGray from 'Img/drag-presa.svg'
import svgDrag from 'Img/drag_presa_white.svg'
import {
  Grid,
  GRID_VARIANT_COLLAPSED,
  GridCell,
  InputText,
  Link,
  Text,
  Title
} from 'mailup-web-components'

// Containers
export const WorkflowBuilderContainer = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--geyser);
`
export const Sidebar = styled.div`
  width: 270px;
  padding: 40px 30px;
  background-color: var(--mercury);
  position: relative;
  flex-shrink: 0;
`
export const RightContainer = styled.div`
  flex: 1;
  padding: 40px 30px 40px 0;
`
export const RightContent = styled.div`
  display: flex;
`
export const DropAreaContainer = styled.div`
  flex: 1;
`
export const DropArea = styled.div`
  position: relative;
  background: transparent;
`

// Items draggable
export const SidebarItem = styled.div`
  user-select: none;
  background-color: var(--java);
  background-size: 8px 18px;
  padding: 12px 15px 10px 30px;
  text-transform: uppercase;
  color: var(--pure-white);
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 10px;

  background-color: ${(props) =>
    props.isDragDisabled ? 'var(--bombay)' : null};
  background-image: url(${svgDrag});
  background-repeat: no-repeat;
  background-position: 5px center;
  background-size: 18px 18px;
`
export const SidebarItemClone = styled(SidebarItem)`
  div + div {
    display: none !important;
  }
`
export const Item = styled.div``

export const InnerItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  border-radius: 0px;
  height: 100%;
  min-height: 100%;
  flex-direction: row;
  position: relative;
`
export const ItemHorizontalLineStart = styled.div`
  background-color: #e3e3e3;
  position: absolute;
  width: 4px;
  height: 50%;
  left: 48px;
  z-index: 0;
  top: 50%;
`

export const ItemStart = styled.div`
  width: 100px;
  min-width: 100px;
  display: flex;
  justify-content: center;
  z-index: 1;
  flex-direction: column;
  align-items: center;
  background-color: var(--wild-sand);
  text-transform: uppercase;
  color: var(--boulder);
  font-weight: 500;
`

export const ItemHorizontalLineEnd = styled.div`
  background-color: #e3e3e3;
  position: absolute;
  width: 4px;
  height: 50%;
  left: 48px;
  z-index: 0;
  top: 0;
`

export const ItemEnd = styled(ItemStart)``

export const ItemHorizontalLine = styled.div`
  background-color: #e3e3e3;
  position: absolute;
  width: 4px;
  height: 100%;
  left: 48px;
  z-index: 0;
`
export const ItemCircle = styled.div`
  width: 100px;
  min-width: 100px;
  display: flex;
  justify-content: center;
  z-index: 1;
`

export const Circle = styled.div`
  width: 26px;
  height: 26px;
  background-color: ${({ error }) =>
    error ? 'var(--sunset-orange)' : 'var(--java)'};
  border-radius: 50%;
  border: 5px solid ${({ error }) => (error ? '#FCB0A8' : '#8bd3e6')};
`

const ItemLeftInner = (props) => <GridCell span={3} {...props} />

export const ItemLeft = styled(ItemLeftInner)`
  padding: 0 15px;
  background-color: var(--java);
  color: var(--pure-white);
  border-radius: 4px 0 0 4px;
  text-transform: uppercase;
  font-weight: 500;
  z-index: 999;
  display: flex;
  align-items: center;
`

const ItemRightInner = (props) => <GridCell span={7} {...props} />
const ItemRightInnerB = (props) => <GridCell span={8} {...props} />

export const ItemRight = styled(ItemRightInner)`
  padding: ${(props) => (props.withInputs ? '10px 15px' : '0 15px')};
`
export const ItemRightB = styled(ItemRightInnerB)`
  padding: ${(props) => (props.withInputs ? '10px 15px' : '0 15px')};
`

const ItemUniqueInner = (props) => <GridCell span={10} {...props} />

export const ItemUnique = styled(ItemUniqueInner)`
  padding: 8px 15px;
  color: var(--boulder);
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  > p {
    line-height: 1.5em;
  }
`

const ItemActionsInner = (props) => <GridCell span={2} {...props} />
const ItemActionsInnerB = (props) => <GridCell span={1} {...props} />

export const ItemActions = styled(ItemActionsInner)`
  padding: 15px;
  display: flex;
  justify-content: right;

  .e-button {
    float: none;
  }

  .e-button + .e-button {
    margin-left: 8px;
    margin-right: 0;
  }

  border-radius: 0 4px 4px 0;

  ${(props) =>
    props.withGhostActions &&
    css`
      background:
        linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
        url(${svgDragGray}) no-repeat right 20px top 20px;
      background-size: 18px 18px;
    `}
`
export const ItemActionsB = styled(ItemActionsInnerB)`
  padding: 15px;
  display: flex;
  justify-content: right;

  .e-button {
    float: none;
  }

  .e-button + .e-button {
    margin-left: 8px;
    margin-right: 0;
  }

  border-radius: 0 4px 4px 0;

  ${(props) =>
    props.withGhostActions &&
    css`
      background:
        linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
        url(${svgDragGray}) no-repeat right 20px top 20px;
      background-size: 18px 18px;
    `}
`

// Text & inputs
export const Notice = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 1rem;
  margin: 0 0.5rem 0.5rem;
  line-height: 1.5;
  color: var(--boulder);

  background: repeating-linear-gradient(
    45deg,
    var(--pure-white),
    var(--pure-white) 15px,
    var(--wild-sand) 15px,
    var(--wild-sand) 30px
  );
`
export const StyledTitle = styled(Title)`
  margin-bottom: 20px;
  text-align: ${(props) => (props.center ? 'center' : null)};
`
export const StyledText = styled(Text)`
  margin-top: 20px;
  font-style: italic !important;
`
export const StyledId = styled(Text)`
  margin-bottom: 8px;
`
export const LinkBold = styled(Link)`
  display: block;
  line-height: ${(props) => (props.verticalCenter ? '58px' : null)};
  margin-top: ${(props) => (props.firstOf2Line ? '8px' : null)};
  text-align: ${(props) => (props.center ? 'center' : null)};
`
export const Input = styled(InputText)`
  display: block;
  input {
    text-align: center;
  }
`
export const Arrows = styled.img`
  display: block;
  position: absolute;
  top: 40px;
  right: -13px;
`
export const MsgError = styled.p`
  margin-top: ${(props) => (props.itemError === 'initialError' ? '0' : '4px')};
  line-height: 1;
  color: var(--sunset-orange);
  font-size: 12px;
`

export const WorkflowBuilderItemInner = (props) => (
  <Grid cols={12} variant={GRID_VARIANT_COLLAPSED} {...props} />
)

export const WorkflowBuilderItem = styled(WorkflowBuilderItemInner)`
  user-select: none;
  line-height: 1.5;
  border-radius: 4px;
  background: var(--pure-white);
  min-height: 60px;
  border: 1px solid var(--geyser);
  margin: 10px 3px 10px 3px;

  .ghost {
    opacity: 0;
    transition: opacity ease-in 0.2s;
    background: var(--pure-white);
  }
  &:hover .ghost {
    opacity: 1;
  }
`
